import React from 'react';

const FiltersContext = React.createContext(false);

export default FiltersContext;